/**
 * Footer Shape (sections/shape-footer.liquid)
 * - Colonnes en accordéons fermés sur mobile, toujours ouvertes (non repliables) à partir de 750px
 * - Bouton « retour en haut » (défilement doux sauf mouvement réduit)
 */

const mobile = window.matchMedia('(max-width: 749px)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function syncAccordions(root = document) {
  root.querySelectorAll('[data-footer-accordion]').forEach((details) => {
    if (!(details instanceof HTMLDetailsElement)) return;
    details.open = !mobile.matches;
  });
}

// Sur desktop, un clic sur le titre ne doit pas replier la colonne
document.addEventListener('click', (event) => {
  const summary = event.target instanceof Element ? event.target.closest('.sh-foot__col-title') : null;
  if (summary && !mobile.matches) event.preventDefault();

  const top = event.target instanceof Element ? event.target.closest('[data-back-to-top]') : null;
  if (top) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }
});

mobile.addEventListener('change', () => syncAccordions());
syncAccordions();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) syncAccordions(event.target);
});
